export enum Direction {
    PREV = "prev",
    NEXT = "next",
}

export interface CommonProps {
    moveSlide: (direction: Direction) => void;
    week: number;
}
